console.log("环境变量的API", import.meta.env.VITE_VUE_APP_BASE_API)
export default {
    method: 'get',
    baseURL: import.meta.env.VITE_VUE_APP_BASE_API, //默认配置(这里不要用process.env,个人百度这个在vite中被废弃掉了,属性名必须以VITE_开头,否则 import.meta.env检测不到)
    timeout: 10000,
    responseType: 'json',
    headers: {
        'X-VERSION': import.meta.env.VITE_VUE_APP_VERSION || '1.0.0',
        'X-ENV': import.meta.env.VITE_NODE_ENV || 'dev'
    } // 前端版本号
}
